import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './containers/Login';
import ManageUsers from './containers/ManageUsers';
import { UserProfile } from './containers/UserProfile';
import { ManagePartners } from './containers/ManagePartners';
import NotFound from './containers/NotFound';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import { MyActivity } from './containers/MyActivity';
import TokenAuth from './containers/TokenAuth';
import { USER_TYPE, USER_TYPE_ADMIN } from './CONSTANTS';
import ManageGroups from "./containers/ManageGroups/ManageGroups";
import ManageTools from './containers/ManageTools';
// import RootCertificatePool from './containers/RootCertificatePool';

export default ({ childProps }) => (
  <Routes>
    <Route
      path="/"      
      element={
        childProps.isAuthenticated ? (
          <Navigate to="/myActivity" />
        ) : (
          <Login {...childProps} />
        )
      }
    />
    <Route path="/login" element={<Login {...childProps} />} />
    <Route
      path="/myActivity"
      element={<AuthenticatedRoute component={MyActivity} props={childProps} />}
    />
    <Route
      path="/manageUsers"
      element={
        <AuthenticatedRoute
          component={ManageUsers}
          props={childProps}
          permissions={{
            roles: USER_TYPE_ADMIN,
          }}
        />
      }
    />
    <Route
      path="/manageGroups"
      element={
        <AuthenticatedRoute
          component={ManageGroups}
          props={childProps}
          permissions={{
            roles: [USER_TYPE.OEM_ADMIN],
          }}
        />
      }
    />
    <Route
      path="/managePartners"
      element={
        <AuthenticatedRoute
          component={ManagePartners}
          props={childProps}
          permissions={{
            roles: [USER_TYPE.SITE_ADMIN],
          }}
        />
      }
    />
    <Route
      path="/userProfile"
      element={
        <AuthenticatedRoute component={UserProfile} props={childProps} />
      }
    />
    <Route
      path="/TokenAuth"
      element={
        <AuthenticatedRoute 
            component={TokenAuth} 
            props={childProps}
            permissions={{
                roles: [USER_TYPE.OEM_ADMIN],
            }}
        />
      }
    />

    <Route
      path="manageTools"
      element = {
        <AuthenticatedRoute
          component={ManageTools}
          permissions={{
            roles: [USER_TYPE.OEM_ADMIN]
          }}
          path="/manageTools" props={childProps} />
      }
    />

    {/* <Route
      path="/rootCertificatePool"
      element={<AuthenticatedRoute component={RootCertificatePool} props={childProps} />}
    /> */}
    <Route
      path="*"      
      element={
        childProps.isAuthenticated ? (
          <NotFound />
        ) : (
          <Login {...childProps} />
        )
      }
    />
  </Routes>
);
